import { PRELUDE } from "./prelude";
import { STYLES_BY_KIND, defaultConfig, drivetrainById, heading } from "./drivetrains";

const L = 0;
const R = 1;
const X = 0;
const Y = 1;

// [stick side, axis] used for each job in a controller layout.
export const STICKS = {
  arcade_left: { fwd: [L, Y], turn: [L, X] },
  arcade_right: { fwd: [R, Y], turn: [R, X] },
  split_left: { fwd: [L, Y], turn: [R, X] },
  split_right: { fwd: [R, Y], turn: [L, X] },
  tank: { left: [L, Y], right: [R, Y] },
  omni_left: { fwd: [L, Y], side: [L, X], turn: [R, X] },
  omni_right: { fwd: [R, Y], side: [R, X], turn: [L, X] },
};

const dirPy = (d) => (d === "R" ? "Direction.COUNTERCLOCKWISE" : "Direction.CLOCKWISE");
const spec = ({ port, dir }) => `(Port.${port}, ${dirPy(dir)})`;
const stick = ([side, axis]) => `hs_stick(${side}, ${axis})`;
const btnPy = (b) => (b === "LT" || b === "RT" ? `"${b}"` : `Button.${b}`);

function setupLine(cfg, dt) {
  const mc = (m) => cfg.motors?.[m.id] || m.default;
  const list = (ms) => `[${ms.map((m) => spec(mc(m))).join(", ")}]`;
  if (dt.kind === "tank") return `hs_tank_setup(${list(dt.motors.filter((m) => m.side === "left"))}, ${list(dt.motors.filter((m) => m.side === "right"))})`;
  if (dt.kind === "omni") {
    const k = 1 / Math.max(...dt.motors.map((m) => Math.max(...heading(m.angle).map(Math.abs))));
    const wheels = dt.motors.map((m) => {
      const [hx, hy] = heading(m.angle);
      return `(Port.${mc(m).port}, ${dirPy(mc(m).dir)}, ${hx.toFixed(3)}, ${hy.toFixed(3)})`;
    });
    return `hs_omni_setup([${wheels.join(", ")}], ${k.toFixed(3)})`;
  }
  return `hs_car_setup(${spec(mc(dt.motors.find((m) => m.steer)))}, ${Number(cfg.steerMax) || 45}, ${list(dt.motors.filter((m) => !m.steer))})`;
}

function driveLine(kind, style) {
  const s = STICKS[style];
  if (kind === "omni") return `hs_omni(${stick(s.fwd)}, ${stick(s.side)}, ${stick(s.turn)})`;
  if (kind === "car") return `hs_car(${stick(s.fwd)}, ${stick(s.turn)})`;
  if (style === "tank") return `hs_tank(${stick(s.left)}, ${stick(s.right)})`;
  return `hs_arcade(${stick(s.fwd)}, ${stick(s.turn)})`;
}

function attachLine(a) {
  const second = a.group === "same" ? a.dir : a.dir === "F" ? "R" : "F";
  const specs = a.ports.map((port, i) => spec({ port, dir: i ? second : a.dir }));
  return `hs_attach([${specs.join(", ")}], ${btnPy(a.pos)}, ${btnPy(a.neg)}, ${Number(a.speed) || 0}, ${a.stop === "hold" ? "True" : "False"})`;
}

// The full MicroPython program the hub runs for a robot setup.
export function generateRcPython(cfg) {
  const dt = drivetrainById(cfg.drivetrain);
  const style = STYLES_BY_KIND[dt.kind].includes(cfg.style) ? cfg.style : defaultConfig(dt.id).style;
  const loop = [driveLine(dt.kind, style), ...(cfg.attachments || []).map(attachLine), "wait(10)"];
  const body = [setupLine(cfg, dt), "hs_xbox()", "while True:", ...loop.map((l) => `  ${l}`)];
  return `${PRELUDE}\n\n# ---- your robot ----\n${body.join("\n")}\n`;
}
